module.exports = __webpack_public_path__ + "media/stylesheets/images/check-1395968b53a7dca3468cc03d2d29b761.svg";